import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

/**
 * Editorial sub-section label. When `title` is a string, the first character
 * is rendered as a warm-gradient Anton drop cap that flows directly into the
 * Fraunces serif tail of the word. Pass `dropCap={false}` to skip the
 * treatment and render the title as-is.
 */
export default function MediaSubLabel({
  letter, // legacy — ignored when title is a string and dropCap is true
  title,
  meta,
  className = '',
  dropCap = true,
}) {
  const classes = ['media-sublabel', className].filter(Boolean).join(' ');
  const titleString = typeof title === 'string' ? title : null;
  const showDropCap = dropCap && titleString && titleString.length > 0;
  const firstChar = showDropCap ? titleString.charAt(0) : null;
  const rest = showDropCap ? titleString.slice(1) : null;

  return (
    <div className={classes}>
      {!showDropCap && letter ? (
        <span className="media-sublabel__letter" aria-hidden="true">{letter}</span>
      ) : null}
      <span className="media-sublabel__title">
        {showDropCap ? (
          <>
            <span className="media-sublabel__dropcap" aria-hidden="true">{firstChar}</span>
            <span className="media-sublabel__rest">{rest}</span>
            <span className="media-sublabel__sr-only">{titleString}</span>
          </>
        ) : (
          title
        )}
      </span>
      {meta ? <span className="media-sublabel__meta">{meta}</span> : null}
    </div>
  );
}

MediaSubLabel.propTypes = {
  letter: PropTypes.node,
  title: PropTypes.node.isRequired,
  meta: PropTypes.node,
  className: PropTypes.string,
  dropCap: PropTypes.bool,
};
